import React, {useContext, useEffect, useState} from 'react';
import Dropzone from "../../../../../../components/dropzone/dropzone.jsx";
import {Card} from "../../../../../../components/card/card.jsx";
import {IndividualContext} from "../../individual-context.jsx";
import {isImageAttach} from "../../resources/attach-utils.js";
import {ATTACH_ORIGINS, getAttachOrigin, getAttachOriginLabel} from "../../resources/attach-origin.js";

const Photos = () => {
    const {individual, boName, setChanges, setAttachList, attachList, attachesDescription, setAttachesDescription, setIndividual} = useContext(IndividualContext)
    const [originFilter, setOriginFilter] = useState([])

    useEffect(() => {
        setIndividual(prev => ({
            ...prev,
            attachs: attachList.filter(a => !a.new)
        }))
    }, [attachList]);

    const photos = attachList.filter(a => a.attachId !== individual.relatedPhotoFaceId && isImageAttach(a));
    const originOf = (photo) => getAttachOrigin(photo, individual);
    const countByOrigin = (origin) => photos.filter(photo => originOf(photo) === origin).length;

    const filteredPhotos = originFilter.length
        ? photos.filter(photo => originFilter.includes(originOf(photo)))
        : photos;

    const toggleOrigin = (origin) => setOriginFilter(prev => (
        prev.includes(origin) ? prev.filter(o => o !== origin) : [...prev, origin]
    ));

    const originOptions = [
        {key: "all", label: "Todas", total: photos.length},
        ...ATTACH_ORIGINS.map(origin => ({key: origin, label: getAttachOriginLabel(origin), total: countByOrigin(origin)}))
    ];

    return (
        <>
            <Card className={"mb-2"}>
                <Card.Header className={"flex flex-wrap gap-2 items-center bg-white! py-3! px-5!"}>
                    <div className={"flex flex-wrap bg-gray-100 border border-gray-300 rounded-md p-0.5 gap-0.5"}>
                        {
                            originOptions.map(({key, label, total}) => {
                                const active = key === "all" ? !originFilter.length : originFilter.includes(key);

                                return (
                                    <button
                                        key={key}
                                        type="button"
                                        disabled={!total && !active}
                                        onClick={() => key === "all" ? setOriginFilter([]) : toggleOrigin(key)}
                                        className={[
                                            "flex items-center gap-1.5 px-3 py-1 rounded text-[13px] font-semibold cursor-pointer transition-colors disabled:cursor-default disabled:text-gray-300 disabled:hover:text-gray-300",
                                            active ? "bg-white text-[#063A6C] shadow-sm" : "text-gray-500 hover:text-gray-700"
                                        ].join(" ")}
                                    >
                                        {label} <span className={"font-normal"}>({total})</span>
                                    </button>
                                )
                            })
                        }
                    </div>
                </Card.Header>

                <Card.Body>
                    <Dropzone
                        attaches={filteredPhotos}
                        setAttaches={(prev) => {
                            setChanges(prev => (prev.includes("photos") ? prev : [...prev, "photos"]))
                            setOriginFilter([])
                            setAttachList(prev)
                        }}
                        attachesDescription={attachesDescription}
                        setAttachesDescription={setAttachesDescription}
                        accept={"image/*"}
                        tagLabel={(photo) => getAttachOriginLabel(originOf(photo))}
                        acceptOthers={false}
                        withoutCard
                    />
                </Card.Body>
            </Card>
        </>
    );
};

export default Photos;
